import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";

const tilleggData = [
  {
    id: "panel",
    category: "INNVENDIGE PANEL",
    subtitle: "Velg material for innvendige vegger.",
    options: [
      {
        name: "TERMO ASP",
        price: "+8 000 NOK",
        img: "https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/3f9e75e83_Thermo.png",
        desc: "Varmebehandlet asp med forbedret stabilitet og fuktmotstand. Mørkere tone enn vanlig asp, med et eksklusivt og moderne utseende.",
      },
      {
        name: "OR",
        price: "INKL.",
        img: "https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/2af13cd97_Zrzutekranu2026-04-8o235241.png",
        desc: "Klassisk or-panel med lys, jevn tekstur. Avgir lite harpiks, tåler varme godt og gir en rolig, tradisjonell badstueatmosfære.",
      },
      {
        name: "ABACHI",
        price: "+5 000 NOK",
        img: "https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/9393d8a16_Abachi.png",
        desc: "Afrikansk treslag med svært lav varmeledningsevne — perfekt rundt ovn og benker. Glatt overflate og lys farge gir et premium-preg.",
      },
      {
        name: "SORT ASP STS4 IGNITE",
        price: "+15 000 NOK",
        img: "https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/9193d7b00_ThermoOr.jpg",
        desc: "Termobehandlet asp med eksklusiv IGNITE sort finish. Intens mørk fargetone gir et eksklusivt og minimalistisk uttrykk.",
      },
    ],
  },
  {
    id: "ovn",
    category: "BADSTUEOVN",
    subtitle: "Velg ovntype og størrelse.",
    options: [
      {
        name: "HUUM HIVE WOOD 13 kW",
        price: "+18 000 NOK",
        img: "https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/91065fd62_HuumWood.png",
        desc: "Vedfyrt ovn med høy virkningsgrad. Ca. 105 kg stein gir jevn temperatur og myk, stabil damp.",
      },
      {
        name: "HUUM HIVE MINI 9 kW",
        price: "INKL.",
        img: "https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/114c6c678_HuumHivemini6kw.png",
        desc: "Kompakt og stilren elektrisk ovn fra HUUM. Holder ca. 40 kg stein for jevn og behagelig damp.",
      },
    ],
  },
  {
    id: "gulv",
    category: "GULV",
    subtitle: "Velg gulvmateriale.",
    options: [
      {
        name: "STEINFLIS",
        price: "+8 000 NOK",
        img: "https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/20a8ca98f_Steingulv.jpg",
        desc: "Naturlig steinflis som akkumulerer varme og avgir den jevnt. Lett å renholde og gir et eksklusivt spa-preg.",
      },
      {
        name: "BEHANDLET TRE",
        price: "INKL.",
        img: "https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/f1d8f1215_Tregulv.png",
        desc: "Varmebehandlet tregulv med oljebehandlet overflate for økt fuktmotstand. Behagelig å gå på og gir en naturlig badstuopplevelse.",
      },
    ],
  },
  {
    id: "dor",
    category: "DØRER",
    subtitle: "Velg dørtype og materiale.",
    options: [
      {
        name: "TREDØR",
        price: "+8 000 NOK",
        img: "https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/35a62e42d_Tredr.jpg",
        desc: "Massiv tredør for maksimal isolasjon og autentisk badstuopplevelse. God varmebevaring og tidløst nordisk utseende.",
      },
      {
        name: "GLASSDØR (KLAR)",
        price: "INKL.",
        img: "https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/8f98ae849_Glassdor.png",
        desc: "Standard klart glassdør som slipper inn naturlig lys. Varmeherdet glass og aluminiumramme for lang holdbarhet.",
      },
      {
        name: "GLASSDØR (BRONSE)",
        price: "+5 000 NOK",
        img: "https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/310ff340d_IMG_9371.jpg",
        desc: "Bronsetonet glass gir privatliv og et eksklusivt, varmt utseende. Harmonerer med tremateriell og naturlige farger.",
      },
    ],
  },
  {
    id: "vindu",
    category: "VINDU",
    subtitle: "Velg glassbehandling.",
    options: [
      {
        name: "KLART GLASS",
        price: "INKL.",
        img: "https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/c518b32ca_ClearGlass.png",
        desc: "Naturlig gjennomsiktig glass uten tinting. Maksimal isolasjon og fullt fokus på varme og avslapping.",
      },
      {
        name: "LETT TONERT GLASS",
        price: "+8 000 NOK",
        img: "https://media.base44.com/images/public/69db395aa041ab4d87ab84d7/a7e571542_Lett.png",
        desc: "Lett tonert glass som bringer inn naturlig lys og gir utsikt uten å påvirke varmebevaring vesentlig.",
      },
      {
        name: "STERKT TONERT GLASS",
        price: "+15 000 NOK",
        img: "https://media.base44.com/images/public/69db395aa041ab4d87ab84d7/e063f5b28_Mrkglass.png",
        desc: "Sterkt tonert glass som gir maksimal privatliv og reduserer dagslys. Full kontroll over lys og atmosfære.",
      },
    ],
  },
  {
    id: "lys",
    category: "BELYSNING",
    subtitle: "Velg belysning.",
    options: [
      {
        name: "LYSSTERAPI RGB",
        price: "+10 000 NOK",
        img: "https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/16d3dd2b9_RGB.png",
        desc: "RGB LED-system med justerbare farger. Lysterapi som skaper stemning med varme og kølige toner.",
      },
      {
        name: "GRUNNLEGGENDE BELYSNING",
        price: "INKL.",
        img: "https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/a6062413e_14b978a72_ThermoAlder.png",
        desc: "Varmt LED-lys i tretone som skaper en rolig og avslappende atmosfære. Energieffektivt og jevnt lys.",
      },
    ],
  },
];

function TilleggCard({ item }) {
  const [idx, setIdx] = useState(0);
  const [direction, setDirection] = useState(1);
  const opt = item.options[idx];
  const total = item.options.length;

  const go = (dir) => {
    setDirection(dir);
    setIdx(i => (i + dir + total) % total);
  };

  return (
    <div className="flex flex-col">
      <div className="relative aspect-[4/3] overflow-hidden rounded-sm">
        <AnimatePresence mode="wait" custom={direction}>
          <motion.img
            key={idx}
            src={opt.img}
            alt={opt.name}
            className="absolute inset-0 w-full h-full object-cover"
            custom={direction}
            initial={{ opacity: 0, x: direction * 60 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: direction * -60 }}
            transition={{ duration: 0.3 }}
          />
        </AnimatePresence>

        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent pointer-events-none" />

        <div className="absolute bottom-0 left-0 px-4 pb-3">
          <p className="text-white text-lg tracking-[0.2em] uppercase font-body font-semibold">{opt.name}</p>
          {opt.price === "INKL." && (
            <p className="text-sm font-body font-bold text-[#6fcf97]">Standard inkludert</p>
          )}
        </div>

        <button onClick={() => go(-1)} className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black/40 hover:bg-black/70 flex items-center justify-center text-white transition-colors">
          <ChevronLeft size={16} />
        </button>
        <button onClick={() => go(1)} className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black/40 hover:bg-black/70 flex items-center justify-center text-white transition-colors">
          <ChevronRight size={16} />
        </button>

        <div className="absolute top-3 left-1/2 -translate-x-1/2 flex gap-1.5">
          {item.options.map((_, i) => (
            <button key={i} onClick={() => { setDirection(i > idx ? 1 : -1); setIdx(i); }}
              className={`w-1.5 h-1.5 rounded-full transition-all ${i === idx ? "bg-white scale-125" : "bg-white/40"}`} />
          ))}
        </div>
      </div>

      <div className="pt-4">
        <p className="text-lg tracking-[0.25em] uppercase text-black font-body mb-1">{item.category}</p>
        <AnimatePresence mode="wait">
          <motion.p
            key={idx}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -6 }}
            transition={{ duration: 0.2 }}
            className="text-foreground/60 text-2xl leading-relaxed font-body"
          >
            {opt.desc}
          </motion.p>
        </AnimatePresence>
      </div>
    </div>
  );
}

export default function CortinaTilleggSection() {
  return (
    <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-20 md:py-24">
      <p className="text-xs tracking-[0.3em] uppercase text-foreground/40 font-body mb-2">TILLEGG</p>
      <h2 className="font-heading text-3xl md:text-5xl font-light mb-3">Valgfrie tillegg for Cortina</h2>
      <p className="text-foreground/50 font-body text-2xl mb-12">Bruk pilene for å bla gjennom tilgjengelige alternativer.</p>

      <div className="grid md:grid-cols-3 gap-10 mb-16">
        {tilleggData.map((item) => (
          <TilleggCard key={item.id} item={item} />
        ))}
      </div>

      <div className="text-center">
        <a
          href="/sauna-cortina-konfigurator"
          className="inline-block px-10 py-4 bg-foreground text-background text-sm tracking-[0.15em] uppercase font-body hover:bg-foreground/85 transition-all duration-200 rounded-sm"
        >
          Konfigurer din CORTINA
        </a>
      </div>
    </div>
  );
}